import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { isStaticTextComponent } from '../../utils';
import { WorkflowComponentProps } from './WorkflowComponent';
import { WorkflowComponentStyles } from './WorkflowComponentStyles';

/** @deprecated Use StaticTextEditField instead. */
export function WorkflowStaticTextComponent(props: WorkflowComponentProps) {
  if (!isStaticTextComponent(props.component)) {
    return null;
  }
  return (
    <MBView centerVertically paddingVertical={1} style={WorkflowComponentStyles.container}>
      <View flex>
        <Text>{props.component.text}</Text>
      </View>
    </MBView>
  );
}
